import { COMPANY_ADDRESS, COMPANY_NAME, SITE_DOMAIN, SITE_URL } from './site';

/** Opulence Technologies — shared contact details across Opulence sites */
export const PHONE = '1-866-617-2764';
export const PHONE_RAW = '+18666172764';

export const CONTACT = {
  phone: PHONE,
  phoneTel: PHONE_RAW,
  email: `support@${SITE_DOMAIN}`,
  website: SITE_DOMAIN,
  websiteUrl: SITE_URL,
  company: COMPANY_NAME,
  address: COMPANY_ADDRESS,
  hoursWeekdays: 'Mon–Fri: 8AM–8PM EST',
  hoursSaturday: 'Sat: 9AM–5PM EST',
};

export const phoneHref = `tel:${CONTACT.phoneTel}`;
